import { Injectable } from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable() export class ConfirmDialogService {
  private subject = new Subject<any>();
  constructor() { }

  confirmThis(messages: string[], yesCallback: () => void, noCallback: () => void): void {
    // Clear any previous dialog
    this.subject.next(null);

    // Show the new dialog with a small delay to ensure UI updates
    setTimeout(() => {
      this.subject.next({
        type: 'confirm',
        text: messages,
        yesFn: () => {
          this.subject.next(null); // Close the dialog
          if (yesCallback) {
            yesCallback();
          }
        },
        noFn: () => {
          this.subject.next(null); // Close the dialog
          if (noCallback) {
            noCallback();
          }
        }
      });
    }, 50);
  }


  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
